export type DateRangePreset = 'last_30_days' | 'last_90_days' | 'last_12_months';

export type DateRangeCustom = { from: Date; to: Date };

export type DateRangeValue = DateRangePreset | DateRangeCustom;

export type ToolbarFilters = {
  currency: string | null;
  // Bank (CHECKING) tab date filter: a preset window or a custom range.
  dateRange: DateRangeValue;
  // Credit Card (CARD) tab date filter (DA-19485): the selected payment date as the backend's
  // value-date option id (ISO 'YYYY-MM-DD'), sent back verbatim as date_from === date_to. null
  // until the picker seeds the newest date; unused (ignored) on the Bank tab, which uses dateRange.
  paymentDate: string | null;
  search: string;
  // Account filter selection.
  // Bank tab (BankAccountsFilter, multi-select): empty array = all accounts (no filter);
  // a non-empty list narrows to those account ids.
  // Credit Card tab (CardAccountFilter, single-select, DA-19483): exactly one card id whenever
  // the tab has cards ([] "all" is Bank-only); stays [] only in the zero-cards empty state.
  // Seeded / corrected to the first card by BankFeedRoute.
  // Reset per tab on tab switch (account id-spaces differ per accountType).
  accountIds: string[];
};

export const TOOLBAR_FILTERS_INITIAL: ToolbarFilters = {
  currency: null,
  dateRange: 'last_30_days',
  paymentDate: null,
  search: '',
  accountIds: [],
};
